'use strict';

module.exports = Object.getOwnPropertyNames;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/var/getOwnPropertyNames.js
// module id = 312
// module chunks = 0